//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import hiButton from "../../../components/button/Index";
import {
  DEVICE,
  CURRENT_USER_INFO_SIMPLE,
} from "../../../store/mutation-types";
import { paypalUrl } from "../../../services/payment";
import { showErrorMsg } from "../../../utils/error";
import { mapGetters } from "vuex";

export default {
  name: "PayPalConfirmComponent",
  components: { hiButton },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
      device: DEVICE,
    }),
    isIos() {
      return this.device === "ios";
    },
  },
  data() {
    return {
      showModal: false,
      params: null,
    };
  },
  methods: {
    /**
     * 支付按钮点击回调
     */
    async subscribeClick() {
      try {
        let sale = !this.user.existPaypalSubscription;
        this.$loading.show();
        try {
          // eslint-disable-next-line
          if (AndroidWebView) {
            console.log(
              "发现是安卓设备开始请求AndroidWebView.paypalFailed()方法"
            );
            // eslint-disable-next-line
            const callback = AndroidWebView.paypalFailed();
            console.log(`获取到安卓的返回值(原始值) -> ${callback}`);
            const payPalFail = Boolean(callback); // 2018.11.22 通过安卓判断用户是否支付失败
            sale = payPalFail;
            console.log(`根据返回值计算sale -> ${sale}`);
          }
        } catch (e) {}
        // 重新获取支付地址
        const url = await paypalUrl({ id: this.params.id, sale });
        // 隐藏弹出
        this.showModal = false;
        window.location.href = url;
      } catch (e) {
        showErrorMsg(e);
        this.$loading.hide();
      }
    },
    /**
     * 点击取消按钮隐藏弹出
     */
    cancel() {
      console.log("this.params", this.params);
      this.showModal = false;
      this.$router.push({ name: "MyPlanPage" });
    },
    show({ params }) {
      console.log(params);
      // 拷贝参数
      this.params = params;
      this.showModal = true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/payment/paypal_error_confirm/Index.vue